export default __webpack_public_path__ + "static/media/icon-micro.bdf33748.svg";